const backendUrl = "https://group12-backend.onrender.com";
// const backendUrl = 'https://group12-backend.onrender.com';

module.exports = { backendUrl };
